/**
 * Daily Metrics Chart Component
 * Simple line chart showing daily ticket volume
 */

import React from 'react';

export default function DailyMetricsChart({ dailyMetrics }) {
  if (!dailyMetrics || dailyMetrics.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No daily metrics available
      </div>
    );
  }

  // Calculate max value for scaling
  const maxValue = Math.max(...dailyMetrics.map((d) => d.total_tickets || 0));

  return (
    <div className="space-y-4">
      <div className="flex gap-4 text-xs text-gray-600">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-blue-500 rounded"></div>
          <span>New Tickets</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-green-500 rounded"></div>
          <span>Resolved</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-orange-500 rounded"></div>
          <span>Pending</span>
        </div>
      </div>

      <div className="space-y-2">
        {dailyMetrics.slice(0, 10).map((metric, index) => {
          const date = new Date(metric.metric_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
          });
          const pctTotal = ((metric.total_tickets || 0) / maxValue) * 100;
          const pctResolved = ((metric.resolved_count || 0) / maxValue) * 100;
          const pctPending = ((metric.pending_count || 0) / maxValue) * 100;

          return (
            <div key={index} className="flex items-center gap-3">
              <span className="text-xs text-gray-600 w-16">{date}</span>
              <div className="flex-1 h-6 bg-gray-100 rounded relative overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-blue-500"
                  style={{ width: `${pctTotal}%` }}
                ></div>
                <div
                  className="absolute inset-y-0 left-0 bg-green-500"
                  style={{ width: `${pctResolved}%` }}
                ></div>
                <div
                  className="absolute inset-y-0 left-0 bg-orange-500"
                  style={{ width: `${pctPending}%` }}
                ></div>
              </div>
              <span className="text-xs text-gray-600 w-8 text-right">
                {metric.total_tickets}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
